import BaseRecaptchaInstance from './base_instance';

class FakeRecaptchaInstance extends BaseRecaptchaInstance {
  execute = (action) => {
    return new Promise((resolve, reject) => {
      resolve(`mock-token-for-${action}-action`);
    });
  };

  getSiteKey = () => 'mock-site-key';
  hideBadge = () => {};
  showBadge = () => {};
}

export default FakeRecaptchaInstance;
